import { useEffect } from 'react';

import { OrgStatus } from '@constants/generic';
import { useAppDispatch, useAppSelector } from '@core/store';

import {
  KYC_PENDING_BANNER,
  KYC_VERIFICATION_PENDING_BANNER,
  KYC_VERIFICATION_SUBMITTED_BANNER
} from '../constants/feStaticBanners';
import { setFeStaticBanners } from '../slices/dynamicComponentsSlice';
import { BannerData, ComponentInstance } from '../types';

interface OrgConfig {
  kyc_status?: string;
}

interface CurrentOrg {
  status?: string;
}

const useFeStaticBanners = () => {
  const dispatch = useAppDispatch();
  const orgConfig = useAppSelector(
    (state) => state.user.orgConfig
  ) as OrgConfig | null;
  const currentOrg = useAppSelector(
    (state) => state.user.currentOrg
  ) as CurrentOrg | null;

  useEffect(() => {
    const banners: ComponentInstance<BannerData>[] = [];

    if (orgConfig?.kyc_status === OrgStatus.PENDING) {
      banners.push(KYC_PENDING_BANNER);
    }

    if (currentOrg?.status === OrgStatus.VERIFICATION_PENDING) {
      banners.push(KYC_VERIFICATION_PENDING_BANNER);
    }

    if (currentOrg?.status === OrgStatus.VERIFICATION_SUBMITTED) {
      banners.push(KYC_VERIFICATION_SUBMITTED_BANNER);
    }

    dispatch(setFeStaticBanners(banners));
  }, [orgConfig?.kyc_status, currentOrg?.status, dispatch]);
};

export default useFeStaticBanners;
